import React from "react";
import ReactDOM from "react-dom/client";
// Order matters: base styles first, then tenant overrides on top.
import "./index.css";
import "./app.css";
import "./styles/tenant.css";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./providers/ThemeProvider";
import { TooltipProvider } from "./com/ui/tooltip";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "@/store/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "sonner";
import { captureReferralCode } from "@/lib/referral";

captureReferralCode();

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);

root.render(
	<Provider store={store}>
		<GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
			<BrowserRouter>
				<ThemeProvider>
					<TooltipProvider>
						<App />
						<Toaster
							position="top-right"
							closeButton
							toastOptions={{
								className: "!bg-[#0C0C0C] !border-[#C9A84C]/20 !text-white !shadow-[0_8px_32px_rgba(0,0,0,0.5)]",
								descriptionClassName: "!text-white/60",
							}}
						/>
					</TooltipProvider>
				</ThemeProvider>
			</BrowserRouter>
		</GoogleOAuthProvider>
	</Provider>,
);
